export default class MobileMenuDropdowns {

    constructor() {
        this.navItems = document.querySelectorAll(".jet-mega-menu-item-has-children > .jet-mega-menu-item__inner");
        this.submenus = document.querySelectorAll(".jet-mega-menu-item-has-children > .jet-mega-menu-sub-menu");
        this.navItemClass = ".jet-mega-menu-item-has-children > .jet-mega-menu-item__inner";
        this.navItemChildClass = ".jet-mega-menu-item-has-children > .jet-mega-menu-item__inner *";
    }

    init() {
        const _this = this;
        document.addEventListener('click', (e) => {
            if(e.target.matches(this.navItemClass)) {
                const isCurrentlyActive = e.target.classList.contains('active-menu-item');
                _this.hideSubmenus();
                _this.clearActiveClasses();

                if(!isCurrentlyActive) {
                    const subMenu = e.target.nextElementSibling;
                    e.target.classList.add('active-menu-item');

                    if (subMenu.classList.contains('jet-mega-menu-sub-menu')) {
                        subMenu.classList.add('active-submenu');
                    }
                }
            }
        });
    }

    clearActiveClasses() {
        this.navItems.forEach((navItem) => {
            navItem.classList.remove('active-menu-item')
        });
    }

    hideSubmenus() {
        this.submenus.forEach((submenu) => {
            submenu.classList.remove('active-submenu');
        });
    }

    scrollCheck(){
        let length = this.navItems.length;

        if( window.pageYOffset > 50 && length ){
            for(let i = 0; i < length; i++){
                let e = this.navItems[i];

                if (!e.classList.contains("jet-mega-menu-item--hover")){
                    continue;
                }
                else{
                    e.classList.remove("jet-mega-menu-item--hover");
                    break;
                }
            }
        }
    }
}